import script from "./Dubbing.vue?vue&type=script&setup=true&lang=js"
export * from "./Dubbing.vue?vue&type=script&setup=true&lang=js"

import "./Dubbing.vue?vue&type=style&index=0&id=6e334481&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e334481"]])

export default __exports__